export const MERGE_CELL_ROW = 3;
export const MERGE_CELL_START = 5;
export const MERGE_CELL_END = 0;
export const CELL_COUNTER = 4;
export const COLUMN_1 = 1;
export const COLUMN_2 = 2;
export const CELL_1 = 1;
export const CELL_2 = 2;
export const CELL_3 = 3;
export const CELL_4 = 4;
export const ROW_1 = 1;
export const ROW_2 = 2;
export const ROW_3 = 3;
export const ROW_4 = 4;



// WEBPACK FOOTER //
// ./helpers/exportexcel/excelconstants.js